export default __webpack_public_path__ + "static/finance-3-36e0b0822f575558dfb4317c6aebf65e.png";